export const cleanLanding = (landing) => {
    if (!landing) return landing;
    let result = {};
    let keys = [
        'needsUpdateOnDimensionChangeLg',
        'needsUpdateOnDimensionChangeSm',
        'needsUpdateOnDimensionChangeXs',
        'needsUpdateOnDimensionChangeApp'
    ];
    for (var key in landing) {
        let val = landing[key];
        for (let i = 0; i < keys.length; i++) {
            if (val[keys[i]]) {
                delete val[keys[i]];
            }
        }
        result[key] = val;
    }
    return result;
}